<template>
  <div>
    <el-dialog
      top="20vh"
      width="450px"
      center
      :title="`${scanFaceObj.bankName ? scanFaceObj.bankName : ''} 现在扫脸`"
      :visible="scanFaceObj.visible"
      @close="HandleCancel()"
    >
      <div
        v-loading="scanFaceLoading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        element-loading-spinner="el-icon-loading"
      >
        <el-button
          @click="HandleScanFaceAction(item)"
          v-for="item in scanFaceObj.faceVideos"
          :key="item.type"
          style="margin: 2px"
          size="mini"
        >
          {{ item.description }}
        </el-button>
      </div>

      <br /><br />
      <el-button
        plain
        @click="HandleStopPushFaceVideoStreaming()"
        style="margin: 2px"
        size="mini"
        type="danger"
      >
        停止线路
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import varCommon from "@/utils/varCommon";
import {
  pushFaceVideoStreaming,
  stopPushFaceVideoStreaming,
  refreshFaceVideoStreaming,
} from "@/api/device";

export default {
  props: {
    scanFaceObj: {
      type: Object,
    },
  },
  data() {
    return {
      scanFaceLoading: false,
    };
  },
  methods: {
    HandleStopPushFaceVideoStreaming() {
      this.$confirm("确定要停止线路吗？", varCommon.message.warning, {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "warning",
      })
        .then(() => {
          this.scanFaceLoading = true;
          stopPushFaceVideoStreaming({
            accId: this.scanFaceObj.id,
          })
            .then((res) => {
              this.$notify.success(res.message);
            })
            .finally(() => {
              this.scanFaceLoading = false;
            });
        })
        .catch(() => {});
    },
    HandleScanFaceAction(item) {
      this.scanFaceLoading = true;
      pushFaceVideoStreaming({
        accId: this.scanFaceObj.id,
        pathType: item.type,
      })
        .then((res) => {
          this.$notify.success(res.message);
        })
        .finally(() => {
          this.scanFaceLoading = false;
        });
    },
    HandleCancel() {
      this.scanFaceLoading = false;
      this.$emit("update:scan-face-obj", {});
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/account/bankOperate/ScanFace.vue